:host {
  display: block;
  height: 56px;
  max-width: 100%;
  padding: var(--spacer) 0 0 0;
}

.title-container {
  max-width: 100%;
  height: 32px;
  min-width: 360px;
}

.early-access-container {
  background-color: var(--blue-layout-101-background);
  padding: calc(var(--spacer) / 2) calc(var(--spacer) * 2);
  margin-left: calc(var(--spacer) * 2);
  gz-title {
    color: var(--black-layout-700-primary);
  }
}

gz-title {
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
}

.feedback-btn .icon {
  margin-right: calc(var(--spacer) / 2);
}

gz-button[class*='feedback-btn']::part(button) {
  text-transform: none;

  &:hover {
    background-color: var(--blue-layout-050-selected);
    text-decoration: none;
  }
}

.icon {
  font-size: 24px;
}

.bitdefender-logo {
  &::part(svgContainer) {
    height: 40px;
  }
  &::part(svgIcon) {
    fill: var(--black-layout-700-primary);
  }
}

:host([displayMode='pdf']) {
  .title-container {
    max-width: 700px;
  }
  .company-name {
    flex: 1;
    border-left: 3px solid var(--title-separator-color);
    margin-left: 8px;
    padding-left: 8px;
    word-break: break-word;
  }

  .company-logo {
    display: block;

    img {
      filter: invert(1);
    }
  }

  .company-logo.is-custom {
    width: 200px;
    height: 25px;
    filter: invert(1);
  }

  .company-logo.is-default {
    width: 200px;
    height: 25px;
    filter: invert(1);
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 383.71 55.16'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;%7D.cls-2%7Bclip-path:url(%23clip-path);%7D.cls-3%7Bfill:%23ffffff;%7D%3C/style%3E%3CclipPath id='clip-path' transform='translate(-99.66 -74.13)'%3E%3Crect class='cls-1' width='582.43' height='215.55'/%3E%3C/clipPath%3E%3C/defs%3E%3Ctitle%3EBitdefender-Logo-BW-%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cg class='cls-2'%3E%3Cpath class='cls-3' d='M252,93.05c-10.42,0-18,7.26-18,18.12s8,18.12,19.52,18.12a24.12,24.12,0,0,0,9.22-1.71l4.91-8.2L267,119a27.94,27.94,0,0,1-12.7,3.35c-5.95,0-11.1-3-11.67-8.19h26.31v-2.38c0-12-7.29-18.76-16.92-18.76m-9.39,14.67c.64-5,3.81-8.2,8.91-8.2,5.4,0,8.71,3.17,8.77,8.2ZM431.28,93.05c-10.44,0-18,7.26-18,18.12s8,18.12,19.52,18.12a24,24,0,0,0,9.2-1.71l4.93-8.2-.65-.35a28,28,0,0,1-12.71,3.35c-5.94,0-11.08-3-11.66-8.19H448.2c1.14-13.52-6.13-21.14-16.92-21.14m-9.39,14.67c.63-5,3.81-8.2,8.9-8.2,5.4,0,8.71,3.17,8.78,8.2ZM310.7,93.05c-10.42,0-18,7.26-18,18.12s8,18.12,19.52,18.12a24.08,24.08,0,0,0,9.22-1.71l4.91-8.2-.66-.35A27.87,27.87,0,0,1,313,122.38c-5.95,0-11.09-3-11.67-8.19h26.32c1.14-13.52-6.14-21.14-16.94-21.14m-9.38,14.67c.64-5,3.81-8.2,8.91-8.2,5.39,0,8.71,3.17,8.77,8.2Zm-168.9-6.12v-.14c5.25-1.58,8.84-5.39,8.84-11.14,0-9.28-7.91-12.8-15.59-12.8h-26v.76l2.61,2.22c3.14,2.56,3.54,3.05,3.54,5.36v42.58h18.35c9.62,0,19.27-3.45,19.27-14.53a12.13,12.13,0,0,0-11-12.3M114.88,85.28h7.47c5.06,0,6.62.7,8.15,2.16a5.79,5.79,0,0,1,1.7,4.39,5.7,5.7,0,0,1-1.75,4.25c-1.5,1.44-3.56,2.14-7.31,2.14h-8.26Zm8.34,35.38h-8.34V106h8.7c7.33,0,10.78,1.87,10.78,7.19,0,6.69-6.48,7.48-11.14,7.48m37.33-38.47A5.55,5.55,0,1,1,155,77a5.31,5.31,0,0,1,5.6,5.18M146.06,93.92h13.27v34.51h-8.64V101.27h0c0-2.85-.16-3.31-3.26-5.7l-1.37-1.09ZM214.74,76l2.71,1.74c2.46,1.57,2.83,2.32,2.83,4.51v16h-.21c-1.8-2.23-5.25-5.25-11.72-5.25-9.85,0-16.69,7.91-16.69,18.12s6.41,18.12,17.05,18.12c4.81,0,9.35-1.87,11.87-6h.14l.9,5.18h7.29V75.38H214.74Zm-4.31,45.5c-6.32,0-10.14-5-10.14-10.35s3.82-10.35,10.14-10.35,10.15,5,10.15,10.35-3.82,10.35-10.15,10.35M393.72,76l1.2.8c4.16,2.63,4.68,3.39,4.68,7.88V98.3h-.22c-1.81-2.23-5.25-5.25-11.72-5.25-9.85,0-16.68,7.91-16.68,18.12s6.4,18.12,17,18.12c4.82,0,9.36-1.87,11.87-6H400l.91,5.18h7.29V75.38h-14.5Zm-4,45.5c-6.32,0-10.14-5-10.14-10.35s3.82-10.35,10.14-10.35,10.14,5,10.14,10.35-3.81,10.35-10.14,10.35m86.12-28v8.34a17.27,17.27,0,0,0-4.17-.65c-8.12,0-9.28,6.84-9.28,8.71v18.48h-8.62V102.92c0-4.34-.23-5-3.74-7.21l-2.17-1.43,0-.38h14.55v5.48h.15a11,11,0,0,1,10.21-6.33,11.35,11.35,0,0,1,3.09.5m-191.6.22h8v7.36h-8v27.3H275.6V104.11c0-2.89-.58-3.53-4-6.24l-4.4-3.58v-.52h8.41V87.48c0-9.37,6.11-15.32,19.33-12.68l2,7.31-.42.34c-6.91-2.72-12.26-1-12.26,5ZM366,106.63v21.8h-8.63V109.22c0-3.8-1-8.4-7-8.4-5.68,0-7.91,4.17-7.91,8.77v18.84h-8.62V102.92c0-4.34-.23-5-3.74-7.21L328,94.28V93.9h6.75v0h7.35v5.25h.14a13.37,13.37,0,0,1,11-6.12c8.15,0,12.85,5.58,12.85,13.58M189,121.49l.28.18s-4.29,6.86-4.28,6.86c-7,1.91-14.94-.12-14.94-11.4v-14c0-2.23-.36-2.11-5.2-6.1l-3.13-2.71v-.41h8.38l3.15-10h5.47v10h9.23v7.32h-9.23v15.65c0,6.23,4.27,6.38,10.28,4.6' transform='translate(-99.66 -74.13)'/%3E%3Cpath class='cls-3' d='M477.89,76.68h-2.12V83.2H476v-3h1.89l.12,0h0l0,0,2,3h.29l-2-3.09h.08A2.7,2.7,0,0,0,479,80a1.84,1.84,0,0,0,.54-.32,1.35,1.35,0,0,0,.36-.51,1.7,1.7,0,0,0,.14-.71,1.63,1.63,0,0,0-.52-1.28,2.39,2.39,0,0,0-1.63-.46m1.92,1.74a1.3,1.3,0,0,1-.75,1.26,2.34,2.34,0,0,1-.7.19,5.94,5.94,0,0,1-.72,0H476v-3h1.87a3.35,3.35,0,0,1,.71.07,1.75,1.75,0,0,1,.63.23,1.12,1.12,0,0,1,.43.46,1.53,1.53,0,0,1,.17.76' transform='translate(-99.66 -74.13)'/%3E%3Cpath class='cls-3' d='M482.92,82.06a5.73,5.73,0,0,0-3-7.48,5.47,5.47,0,0,0-2.22-.45,5.55,5.55,0,0,0-2.23.45,5.67,5.67,0,0,0-1.8,1.22,5.61,5.61,0,0,0-1.22,1.81,5.73,5.73,0,0,0,0,4.45,5.66,5.66,0,0,0,1.22,1.81,5.49,5.49,0,0,0,1.8,1.21,5.55,5.55,0,0,0,2.23.44,5.63,5.63,0,0,0,4-1.65,5.69,5.69,0,0,0,1.23-1.81m-3.12,2.83a5.64,5.64,0,0,1-4.27,0,5.42,5.42,0,0,1-3.33-5.06A5.41,5.41,0,0,1,473.79,76a5.58,5.58,0,0,1,1.74-1.18,5.52,5.52,0,0,1,4.27,0A5.65,5.65,0,0,1,481.53,76a5.5,5.5,0,0,1,1.17,1.74,5.26,5.26,0,0,1,.44,2.12A5.33,5.33,0,0,1,482.7,82a5.73,5.73,0,0,1-1.17,1.74,5.87,5.87,0,0,1-1.73,1.17' transform='translate(-99.66 -74.13)'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E")
    no-repeat right;
    img {
      display: none;
    }
  }
}
